import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { Publicacion } from '../models/publicacion';
@Injectable({
  providedIn: 'root'
})
export class PublicacionService {

  constructor(private http: HttpClient) { }

  private publicaciones: Publicacion[];
  private publicaciones$ = new Subject<Publicacion[]>();

  private publicacion: Publicacion;
  private publicacion$ = new Subject<Publicacion>();

  change(val) {
    this.publicaciones = val;
    this.publicaciones$.next(this.publicaciones);
  }
  get$(): Observable<Publicacion[]> {
    return this.publicaciones$.asObservable();
  }

  changeOne(val) {
    this.publicacion = val;
    this.publicacion$.next(this.publicacion);
  }
  getOne$(): Observable<Publicacion> {
    return this.publicacion$.asObservable();
  }

  getAll(): Observable<Publicacion[]> {
    return this.http.get(environment.apiUrl + 'publicacion')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getFilter(data): Observable<Publicacion[]> {

    return this.http.post(environment.apiUrl + 'publicacion/getFilter', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }


  get(id) {
    return this.http.get(environment.apiUrl + 'publicacion/' + id)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  add(data) {
    return this.http.post(environment.apiUrl + 'publicacion', data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
  edit(data) {
    const apiUrl = environment.apiUrl + 'publicacion';
    const url = `${apiUrl}/${data["id"]}`;


    return this.http.put(url, data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  delete(id) {

    return this.http.delete(environment.apiUrl + 'publicacion/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }


  getTipo() {
    return this.http.get(environment.apiUrl + 'publicacion/getTipo')
      .pipe(map((res: any) => {
        return res;
      }));
  }
  getSeccion() {
    return this.http.get(environment.apiUrl + 'publicacion/getSeccion')
      .pipe(map((res: any) => {
        return res;
      }));
  }
  getYears() {
    return this.http.get(environment.apiUrl + 'publicacion/getYears')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  changeImagePrincipal(formData: FormData, id): Observable<object> {
    return this.http.post(environment.apiUrl + 'publicacion/changeImgPrincipal/' + id, formData)
      .pipe(
        map((res: any) => { return res.data; }),
        catchError(e => throwError(e))
      );
  }

  changeImageExtra(formData: FormData, id): Observable<object> {
    return this.http.post(environment.apiUrl + 'publicacion/changeImgExtra/' + id, formData)
      .pipe(
        map((res: any) => { return res.data; }),
        catchError(e => throwError(e))
      );
  }

  deleteImg(id) {
    return this.http.delete(environment.apiUrl + 'publicacion/deleteImg/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
}
